import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import TvIcon from '@mui/icons-material/Tv';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { youtubeBroadcastsListRouteGenerator } from '../broadcasts/list/youtube-broadcasts-list-routes';
import { youtubePanoramaMessages } from './youtube-panorama.messages';

interface YoutubePanoramaCardsHeaderProps {
  stationSlug: string;
  compact: boolean;
}

/** Title row for the YouTube broadcasts panorama strip on the status screen. */
export function YoutubePanoramaCardsHeader({
  stationSlug,
  compact,
}: YoutubePanoramaCardsHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
        py: compact ? 0.5 : 0.75,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <TvIcon sx={{ fontSize: compact ? 14 : 16, color: 'text.secondary' }} />
        <Typography variant={'caption'} color="text.secondary" sx={{ textTransform: 'uppercase' }}>
          <FormattedMessage
            {...(compact
              ? youtubePanoramaMessages.recentTransmissionTitle
              : youtubePanoramaMessages.recentTransmissionsTitle)}
          />
        </Typography>
      </Box>
      <Tooltip title={<FormattedMessage {...youtubePanoramaMessages.viewAll} />}>
        <IconButton
          component={RouterLink}
          to={youtubeBroadcastsListRouteGenerator.list(stationSlug)}
          color="primary"
          size="small"
          onClick={(event) => event.stopPropagation()}
          sx={{ flexShrink: 0 }}
        >
          <SubscriptionsIcon sx={{ fontSize: compact ? 16 : 20 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
